import { useAsyncEffect } from '@/hooks';
import { downloadBlob } from '@/lib/utils';
import { useStores } from '@/store';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { Grid, GridColumn } from 'semantic-ui-react';
import { FileDisplayCard } from '../FileDisplayCard';

export const OnboardingSubmissionDetailsDocuments = observer(() => {
  const { onboardingDocumentEmployeeStore, temporaryEmployeeStore } = useStores();

  useEffect(() => {
    return () => {
      onboardingDocumentEmployeeStore.clear();
    };
  }, []);

  useAsyncEffect(async () => {
    if (temporaryEmployeeStore.current) {
      await onboardingDocumentEmployeeStore.fetchByTemporaryEmployeeId(
        temporaryEmployeeStore.current.id,
        true,
      );
    }
  }, [temporaryEmployeeStore.current]);

  return (
    <div style={{ paddingRight: 20 }}>
      {onboardingDocumentEmployeeStore.values.length === 0 && 'No documents submitted by employee'}

      <Grid className="spaced-grid" columns={2} relaxed>
        {onboardingDocumentEmployeeStore.values.map(
          ({ id, deleteDatetime, signature, onboardingDocument }) => {
            if (!onboardingDocument?.fileName) {
              return <GridColumn key={`no-file-${id}`}>No file</GridColumn>;
            }

            return (
              <Grid.Column
                key={onboardingDocument.id}
                mobile={16}
                tablet={16}
                computer={8}
                style={{ paddingRight: '1rem !important' }}
              >
                <FileDisplayCard
                  fileTitle={onboardingDocument.title}
                  fileTitleLink={`/onboarding/documents/templates/${onboardingDocument.id}`}
                  checkIconTooltip="Employee submitted the document"
                  signature={signature}
                  isDeleted={!!deleteDatetime}
                  handleDownload={async () => {
                    const { file } = await onboardingDocumentEmployeeStore.download(
                      onboardingDocument.id,
                    );

                    downloadBlob(file, onboardingDocument.fileName);
                  }}
                />
              </Grid.Column>
            );
          },
        )}
      </Grid>
    </div>
  );
});
